import script from "./categoryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./categoryPage.vue?vue&type=script&setup=true&lang=js"

import "./categoryPage.vue?vue&type=style&index=0&id=923a09fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-923a09fc"]])

export default __exports__